import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { DiffEditor } from '@monaco-editor/react';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Button from '../../../common/base/Button';
import Divider from '../../../common/base/Divider';
import Editor from '../../../common/Editor';
import Console from '../Connections/Forms/TransformRuleForm/Console';
import Link from '../../../common/base/Link';
import Loading from '../../../common/base/Loading';
import { Div } from '../../../common/helpers/StyledUtils';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { DashboardContext } from '../DashboardContext';
import { useTheme } from 'styled-components';
import { StyledViewSidebarScrollableSection, StyledViewSidebar, StyledViewSidebarNav, StyledViewSidebarSection } from '../../../layouts/ViewLayout';
import Badge from '../../../common/base/Badge';
import DisplayDate from '../../../common/DisplayDate';
import { useHistory } from 'react-router';
import { CollapsableDataSection } from '../../../common/Data/CollapsableDataSection';
import useLocalStorage from '../../../hooks/useLocalStorage';
const TransformationExecutionDetails: React.FC<{
  transformation_id: string;
  execution_id: string;
  onClose: () => void;
}> = t0 => {
  const $ = _c(87);
  const {
    transformation_id,
    execution_id,
    onClose
  } = t0;
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  const [collapse_execution, setCollapseExecution] = useLocalStorage("prefs:data:execution-diff:collapsed", false);
  const [collapse_console, setCollapseConsole] = useLocalStorage("prefs:data:execution-console:collapsed", false);
  const history = useHistory();
  const active_tab = query.transform_tab || "input";
  const theme = useTheme();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    subscription
  } = useContext(DashboardContext);
  let t1;
  if ($[0] !== execution_id || $[1] !== transformation_id) {
    t1 = APIMethodKeys.transformations.getExecution(transformation_id, execution_id);
    $[0] = execution_id;
    $[1] = transformation_id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== HookdeckAPI.transformations || $[4] !== execution_id || $[5] !== transformation_id) {
    t2 = () => HookdeckAPI.transformations.getExecution(transformation_id, execution_id);
    $[3] = HookdeckAPI.transformations;
    $[4] = execution_id;
    $[5] = transformation_id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: execution
  } = useSWR(t1, t2);
  let t3;
  if ($[7] !== execution?.id || $[8] !== history || $[9] !== transformation_id) {
    t3 = () => {
      history.push(`/transformations/${transformation_id}/edit?input_execution_id=${execution?.id}`);
    };
    $[7] = execution?.id;
    $[8] = history;
    $[9] = transformation_id;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onEdit = t3;
  const t4 = execution?.id;
  let t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      x: 6,
      y: 3
    };
    t6 = {
      justify: "space-between",
      align: "center",
      gap: 3
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      align: "center",
      gap: 3
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== execution) {
    t8 = execution?.created_at && <DisplayDate date={execution.created_at} />;
    $[14] = execution;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = execution?.log_level === "fatal" || execution?.log_level === "error";
  const t10 = execution?.log_level === "warn";
  const t11 = execution?.log_level === "info" || execution?.log_level === "debug";
  const t12 = !execution?.log_level;
  let t13;
  if ($[16] !== execution?.log_level) {
    t13 = execution?.log_level?.toUpperCase() || "OK";
    $[16] = execution?.log_level;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t9) {
    t14 = <Badge danger={t9} warning={t10} primary={t11} success={t12} subtle={true}>{t13}</Badge>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14 || $[25] !== t8) {
    t15 = <Div flex={t7}>{t8}{t14}</Div>;
    $[24] = t14;
    $[25] = t8;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      gap: 2
    };
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = !execution;
  let t18;
  if ($[28] !== onEdit) {
    t18 = () => onEdit();
    $[28] = onEdit;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t17 || $[31] !== t18) {
    t19 = <Button hidden={t17} ghost={true} icon="edit" onClick={t18} />;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== onClose) {
    t20 = <Button ghost={true} icon="close" onClick={onClose} />;
    $[33] = onClose;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t19 || $[36] !== t20) {
    t21 = <Div flex={t16}>{t19}{t20}</Div>;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t15 || $[39] !== t21) {
    t22 = <Div p={t5} flex={t6}>{t15}{t21}</Div>;
    $[38] = t15;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Divider />;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t22) {
    t24 = <StyledViewSidebarNav>{t22}{t23}</StyledViewSidebarNav>;
    $[42] = t22;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  const t25 = !collapse_console ? theme.colors.surface.base.variant_surface_3 : undefined;
  let t26;
  if ($[44] !== t25) {
    t26 = {
      backgroundColor: t25
    };
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  const t27 = collapse_execution ? undefined : theme.colors.surface.base.variant_surface_3;
  let t28;
  if ($[46] !== t27) {
    t28 = {
      backgroundColor: t27
    };
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== collapse_execution || $[49] !== setCollapseExecution) {
    t29 = <Text semi={true} onClick={() => setCollapseExecution(!collapse_execution)}>Transformation execution</Text>;
    $[48] = collapse_execution;
    $[49] = setCollapseExecution;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  const t30 = collapse_execution ? "chevron_down" : "chevron_up";
  let t31;
  if ($[51] !== collapse_execution || $[52] !== setCollapseExecution) {
    t31 = () => setCollapseExecution(!collapse_execution);
    $[51] = collapse_execution;
    $[52] = setCollapseExecution;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t30 || $[55] !== t31) {
    t32 = <Button ghost={true} icon={t30} onClick={t31} />;
    $[54] = t30;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== collapse_execution || $[58] !== t29 || $[59] !== t32) {
    t33 = <CollapsableDataSection embedded={true} collapsed={collapse_execution}>{t29}{t32}</CollapsableDataSection>;
    $[57] = collapse_execution;
    $[58] = t29;
    $[59] = t32;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] !== t28 || $[62] !== t33) {
    t34 = <Div style={t28}>{t33}</Div>;
    $[61] = t28;
    $[62] = t33;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== execution) {
    t35 = <Loading require={[execution]} wrapper={_temp} />;
    $[64] = execution;
    $[65] = t35;
  } else {
    t35 = $[65];
  }
  let t36;
  if ($[66] !== active_tab || $[67] !== collapse_console || $[68] !== collapse_execution || $[69] !== execution || $[70] !== setCollapseConsole || $[71] !== theme || $[72] !== updateSearchQuery) {
    t36 = execution && execution.original_event_data && <StyledViewSidebarSection p={0}><Div hidden={collapse_execution} style={!collapse_execution ? {
        backgroundColor: theme.colors.surface.base.variant_surface_3
      } : undefined}><div style={{
          flexGrow: 1
        }}><Div p={{
            x: 6
          }} flex={{
            align: "center",
            justify: "space-between"
          }}><Tabs compact={true} tabs={[{
              key: "input",
              label: "Input"
            }, {
              key: "output",
              label: "Output"
            }, {
              key: "diff",
              label: "Diff"
            }]} border={false} active_tab={active_tab} onTabSelected={key => updateSearchQuery({
              transform_tab: key
            })} /></Div><Divider />{active_tab === "input" && <Editor height="50vh" value={JSON.stringify(execution.original_event_data, null, 2)} disabled={true} options={{
            scrollBeyondLastLine: false
          }} />}{active_tab === "output" && <Editor height="50vh" value={JSON.stringify(execution.transformed_event_data, null, 2)} disabled={true} options={{
            scrollBeyondLastLine: false
          }} />}{active_tab === "diff" && <DiffEditor original={JSON.stringify(execution.original_event_data, null, 2)} modified={JSON.stringify(execution.transformed_event_data, null, 2)} onMount={(editor, monaco) => {
            monaco.editor.defineTheme("my-theme", {
              base: theme.mode === "dark" ? "vs-dark" : "vs",
              inherit: true,
              rules: [{
                token: "type",
                foreground: theme.colors.on.neutral.primary_neutral
              }, {
                token: "number",
                foreground: theme.colors.on.code.number
              }, {
                token: "string.yaml",
                foreground: theme.colors.on.code.string
              }],
              colors: {
                "editor.background": theme.colors.surface.base.variant_surface_3,
                "diffEditor.background": theme.colors.surface.base.variant_surface_3,
                "diffEditor.insertedTextBackground": `${theme.colors.surface.base.variant_surface_3}99`,
                "diffEditor.removedTextBackground": `${theme.colors.surface.base.variant_surface_3}99`
              }
            });
            monaco.editor.setTheme("my-theme");
          }} options={{
            enableSplitViewResizing: false,
            renderSideBySide: false,
            lineNumbers: "off",
            padding: {
              top: 12,
              bottom: 12
            },
            contextmenu: false,
            readOnly: true,
            domReadOnly: true,
            renderLineHighlightOnlyWhenFocus: true,
            hideCursorInOverviewRuler: true,
            overviewRulerBorder: false,
            guides: {
              indentation: false,
              highlightActiveIndentation: false
            },
            minimap: {
              enabled: false
            },
            scrollbar: {
              vertical: "hidden",
              horizontal: "hidden"
            },
            overviewRulerLanes: 0,
            matchBrackets: "never",
            scrollBeyondLastColumn: 0,
            scrollBeyondLastLine: false,
            fontSize: theme.font_sizes.s.font_size,
            fontFamily: "JetBrains Mono, monospace"
          }} originalLanguage="json" modifiedLanguage="json" height="50vh" />}</div></Div><Divider /><Div style={{
        backgroundColor: collapse_console ? theme.colors.surface.base.surface : theme.colors.surface.base.variant_surface_3
      }}><CollapsableDataSection embedded={true} collapsed={collapse_console}><Text semi={true} onClick={() => setCollapseConsole(!collapse_console)}>Console</Text><Button ghost={true} icon={collapse_console ? "chevron_down" : "chevron_up"} onClick={() => setCollapseConsole(!collapse_console)} /></CollapsableDataSection><Divider />{!collapse_console && <Console.Container lines={execution.logs} dynamic_height={true} />}</Div></StyledViewSidebarSection>;
    $[66] = active_tab;
    $[67] = collapse_console;
    $[68] = collapse_execution;
    $[69] = execution;
    $[70] = setCollapseConsole;
    $[71] = theme;
    $[72] = updateSearchQuery;
    $[73] = t36;
  } else {
    t36 = $[73];
  }
  let t37;
  if ($[74] !== execution || $[75] !== subscription) {
    t37 = execution && !execution.original_event_data && <StyledViewSidebarSection><Text as="p">This request is past your archival period of {subscription.retention_days} days, the request data is no longer available.</Text><Link to="/settings/organization/plans?highlight=retention_days" icon="upgrade">Upgrade Plan</Link></StyledViewSidebarSection>;
    $[74] = execution;
    $[75] = subscription;
    $[76] = t37;
  } else {
    t37 = $[76];
  }
  let t38;
  if ($[77] !== t26 || $[78] !== t34 || $[79] !== t35 || $[80] !== t36 || $[81] !== t37) {
    t38 = <StyledViewSidebarScrollableSection style={t26}>{t34}{t35}{t36}{t37}</StyledViewSidebarScrollableSection>;
    $[77] = t26;
    $[78] = t34;
    $[79] = t35;
    $[80] = t36;
    $[81] = t37;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== t24 || $[84] !== t38 || $[85] !== t4) {
    t39 = <StyledViewSidebar key={t4}>{t24}{t38}</StyledViewSidebar>;
    $[83] = t24;
    $[84] = t38;
    $[85] = t4;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  return t39;
};
export default TransformationExecutionDetails;
function _temp(loading) {
  return <StyledViewSidebarSection>{loading}</StyledViewSidebarSection>;
}